import moment from 'moment';

export default function getFormattedDate(date: Date | string, format = 'DD MMMM YYYY'): string {
  const formattedDate = moment(date).format(format);
  return formattedDate;
}
